/**
 * Stylesheet for the renderer's `track` mode (review panel only). Append it
 * to a preview theme; the print pipeline never renders tracked documents.
 */
export const trackChangesCss = (prefix = 'rd') => [
    `.${prefix}-ins{background:#e6f4ea;color:inherit;text-decoration:underline;text-decoration-color:#1e7e34}`,
    `.${prefix}-del{background:#fdecea;color:#8a1c12;text-decoration:line-through}`,
    `.${prefix}-ins--block,.${prefix}-del--block{display:block;text-decoration:none}`,
    `.${prefix}-ins--block{border-left:3px solid #1e7e34;padding-left:6px}`,
    `.${prefix}-del--block{border-left:3px solid #c5221f;padding-left:6px;opacity:.75}`,
    `.${prefix}-del--block *{text-decoration:line-through}`,
    `[data-moved-by]{outline:1px dashed #1a73e8;outline-offset:2px}`,
].join('\n');
/**
 * Colour layers for a tracked review view (ADR-0102 addendum 2), appended
 * after `trackChangesCss`: suggestions stay red/green, the author's
 * adaptations turn violet. Put `${prefix}-hide-adaptations` on a container
 * to show adaptations as plain text (the toggle), and
 * `${prefix}-hide-suggestions` to hide open suggestions (the clean preview).
 */
export const changeLayersCss = (prefix = 'rd') => [
    `.${prefix}-ins--adaptation{background:#f1ebfb;text-decoration-color:#6d28d9}`,
    `.${prefix}-del--adaptation{background:#f6f0fd;color:#5b21b6}`,
    `.${prefix}-ins--adaptation.${prefix}-ins--block{border-left-color:#6d28d9}`,
    `.${prefix}-del--adaptation.${prefix}-del--block{border-left-color:#8b5cf6}`,
    `[data-suggestion="proposed"]{outline:1px solid #c5221f33;outline-offset:1px}`,
    `.${prefix}-hide-adaptations .${prefix}-ins--adaptation{background:none;text-decoration:none;border-left:0;padding-left:0}`,
    `.${prefix}-hide-adaptations .${prefix}-del--adaptation{display:none}`,
    `.${prefix}-hide-suggestions [data-suggestion="proposed"].${prefix}-ins{display:none}`,
    `.${prefix}-hide-suggestions [data-suggestion="proposed"].${prefix}-del{background:none;color:inherit;text-decoration:none;border-left:0;padding-left:0;opacity:1}`,
    `.${prefix}-hide-suggestions [data-suggestion="proposed"].${prefix}-del *{text-decoration:none}`,
].join('\n');
//# sourceMappingURL=track.js.map